import {useSelector} from "react-redux";
import {isLoggedIn} from "../selectors";

const useIsLoggedIn = () => {
    return useSelector(isLoggedIn);
}

export default useIsLoggedIn;